<script lang="ts" module>
	export interface ButtonInputProps {
		classes?: { button?: string; buttonInputClasses?: InputClasses };
		value?: string | undefined;
		loading?: boolean | undefined;
		disabled?: boolean | undefined;
		placeholder: string;
		name: string;
		spellcheck?: string;
		label?: string | undefined;
		class?: string;
		dataCy: string;
		required?: boolean;
		inputVariant?: 'light' | 'dark';
		buttonVariant?: 'light' | 'dark';
		onblur?: () => void;
		error?: false | string[] | string;
		success?: string | undefined;
		onchange?: (e: Event) => void;
		oninput?: (e: Event) => void;
		onkeyup?: (e: Event) => void;
		children?: import('svelte').Snippet;
		helper?: import('svelte').Snippet;
		dark?: boolean;
		id?: string;
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { Button } from '../Button';
	import { Input } from '../Input';
	import type { InputClasses } from '../Input/Input.svelte';

	let {
		classes = {},
		value = $bindable(undefined),
		loading = undefined,
		disabled = undefined,
		placeholder,
		name,
		dataCy,
		inputVariant,
		buttonVariant,
		onblur,
		onchange,
		onkeyup,
		children,
		helper: helperSnippet,
		...rest
	}: ButtonInputProps = $props();

	let dataCyPrefix = $derived(`${dataCy}-button`);
</script>

<Input
	dataCy={dataCyPrefix}
	dark={inputVariant === 'dark'}
	{placeholder}
	{name}
	{...rest}
	classes={classes.buttonInputClasses || {}}
	class={twMerge('rounded-e-none', rest.class)}
	bind:value
	{onblur}
	{onchange}
	{onkeyup}
>
	<Button
		{loading}
		{disabled}
		type="submit"
		dataCy={`${dataCyPrefix}-input`}
		variant={buttonVariant === 'dark' ? 'primary' : 'secondary'}
		size="md"
		class={twMerge(
			classNames('ml-[-4px]', {
				'rounded-s-none': buttonVariant !== inputVariant,
				'border-gray-0 hover:border-gray-0': buttonVariant === 'light' && inputVariant === 'dark'
			}),
			classes.button
		)}
	>
		{@render children?.()}
	</Button>

	{#snippet helper()}
		{@render helperSnippet?.()}
	{/snippet}
</Input>
